import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const WelcomeSeries = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M20.7439 17.8819C21.1209 16.7042 19.4295 10.5541 22.6279 10.2005C24.0884 12.7478 26.4622 23.7577 20.5481 26.6342C13.257 30.1805 7.52655 23.8631 6.13076 18.2961C5.37297 15.2738 6.07443 13.0062 7.92011 13.5146C6.95086 9.64878 8.61849 6.76537 10.4826 7.94152C10.2371 4.22291 13.3349 2.78138 13.9967 7.06055C14.303 4.85464 17.0022 3.56779 17.3002 6.23225C17.9017 11.6097 18.1406 14.6499 20.7439 17.8819Z"
          fill="#FFDB59"
        />
        <path
          d="M13.9967 7.06055C14.303 4.85464 17.0022 3.5678 17.3002 6.23225C17.9017 11.6097 18.1406 14.6499 20.7439 17.8819C21.1209 16.7042 19.4295 10.5541 22.6279 10.2005C24.0884 12.7478 26.4622 23.7577 20.5481 26.6342C13.257 30.1805 7.52655 23.8631 6.13076 18.2961C5.37297 15.2738 6.07443 13.0062 7.92011 13.5146M13.9967 7.06055C13.3349 2.78138 10.2371 4.22291 10.4826 7.94152M13.9967 7.06055C13.999 10.0482 14.8944 14.1864 15.9366 16.4352M10.4826 7.94152C10.6427 10.3668 11.225 14.18 13.0725 17.3774M10.4826 7.94152C8.61849 6.76537 6.95086 9.64878 7.92011 13.5146M7.92011 13.5146C8.29019 14.9906 8.75805 17.6 10.7986 20.3755"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.11115 22.3806C5.69553 25.7896 9.93247 28.3707 11.4422 28.9551"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.79619 26.1793C4.26795 27.5859 6.65753 29.4419 8.13062 29.9528"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.718 8.06396C26.9307 11.7084 27.6465 16.7193 26.9957 19.0621"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.1985 9.04004C29.1454 10.4113 29.7767 14.2763 29.5242 15.1638"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default WelcomeSeries
